export function sendEvent(eventName: string, element?: Element): void {
  const event = document.createEvent('Event');
  event.initEvent(eventName, true, true);
  (element || document).dispatchEvent(event);
}

export function addEventHandler(
  eventName: string,
  handler: EventListenerOrEventListenerObject
) {
  document.addEventListener(eventName, handler);
}

export function removeEventHandler(
  eventName: string,
  handler: EventListenerOrEventListenerObject
) {
  document.removeEventListener(eventName, handler);
}
